var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDustbin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 0C5.25 0 4.28571 1.0125 4.28571 2.25H2.14286C0.964286 2.25 0 3.2625 0 4.5H15C15 3.2625 14.0357 2.25 12.8571 2.25H10.7143C10.7143 1.0125 9.75 0 8.57143 0H6.42857ZM2.14286 6.75V17.5725C2.14286 17.82 2.31429 18 2.55 18H12.4714C12.7071 18 12.8786 17.82 12.8786 17.5725V6.75H10.7357V14.625C10.7357 15.255 10.2643 15.75 9.66429 15.75C9.06429 15.75 10.5077 15.956 10.5077 15.326L9.66429 15.75H6.42857H4.28571C4.28571 16.38 5.97857 15.75 5.37857 15.75C4.77857 15.75 4.30714 15.255 4.30714 14.625V6.75H2.16429H2.14286Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbin);
export default __webpack_public_path__ + "static/media/dustbin.227b17ecc6239d716fe795759a3f0c4b.svg";
export { ForwardRef as ReactComponent };